import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "accordion-item border-0" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { style: {"width":"100%","display":"flex","position":"relative"} }
const _hoisted_5 = ["data-bs-target", "disabled"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_11 = {
  key: 0,
  class: "d-flex flex-wrap align-items-center mt-2",
  style: {"gap":"6px"}
}
const _hoisted_12 = {
  key: 0,
  class: "font-size-12",
  style: {"color":"#888"}
}
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-end mt-3"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 2 }

import { JsonForms } from "@jsonforms/vue";
import { createAjv } from "@jsonforms/core";
import {
  computed,
  inject,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  provide,
  ref,
  watch,
} from "vue";
import { cloneDeep, isEmpty, isEqual, omit } from "lodash-es";
import { ElSelect, ElOption, ElTag, ElTooltip } from "element-plus";
import { renderers, styles } from "@/core/json-forms";
import i18n from "@/core/i18n/i18n";
import { getPreferenceValue } from "@/core/preferences/preferences";
import FunctionSelector from "@/core/json-forms/components/FunctionSelector.vue";
import { ARRAY_INJECTION_ENABLED_KEY } from "@/core/json-forms/components/arrayInjection";
import {
  generateJoltTransformation,
  connectWebsocket,
  isAIJoltEnabledForTenant,
  isAIJoltAutoValidateEnabled,
  isAIJoltFastResolveEnabled,
  resolveJoltFields,
  recommendPrompts,
  getJoltTransformationResult,
} from "@/flow/services/flow.service";
import {
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
  parseMetaoutputIndexFromName,
  parseOutputIndexFromName,
} from "@/flow/utils/outputReferenceUtils";
import { TYPE } from "vue-toastification";
import { showAlert } from "@/core/popup";
import WebsocketUrlProvider from "@/core/services/websocketUrl.provider";
// Import shared state that persists across component instances
import { EventBus } from "@/eventBus";
import { authInfo } from "@/core/auth";
import {
  joltState,
  pendingJoltResult,
  pushJoltMessageToBuffer,
} from "./joltState";

const TRANSFORMATION_SPEC_KEY = "OPTIONS#x-oneteg-transformation-spec";
const JOLT_WS_MAX_RECONNECT_ATTEMPTS = 3;
const JOLT_WS_RECONNECT_DELAY_MS = 2000;
const JOLT_POLLING_FALLBACK_MS = 8000;


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestBodyView',
  props: {
    requestBodies: {},
    stepIdx: {},
    idx: {},
    outputList: {},
    existingData: {},
    childCount: {},
    objectInjectionModalVisibleKey: {},
    overrideObjectList: {},
    expressions: {},
    userDefinedVariables: {},
    systemVariables: {},
    metaoutput: {},
    connectorIsSwagger: { type: Boolean },
    connectorSpecId: {},
    transformedInput: {},
    transformedOutput: {},
    transformedPrompt: {},
    isStepChanged: { type: Boolean },
    isSimulating: { type: Boolean },
    simulationDataRefreshKey: {}
  },
  emits: [
  "handle-click-event",
  "update-data",
  "change-object-injection-modal-visible-key",
  "change-override-object-list",
  "on-input-change",
  "expression-drawer",
  "update-show-custom-request-body",
  "simulate-for-spec",
  "save-after-spec",
],
  setup(__props: any, { emit: __emit }) {

provide("styles", styles);

const isGeneratingJolt = ref(false);
const aiJoltEnabled = ref(false);
const autoValidateEnabled = ref(false);
const isValidating = ref(false);
// Fast-resolve (skip pre-generation full simulation) — gated by master property.
const fastResolveEnabled = ref(false);
// One-shot resolved values from the fast path; preferred over props.transformed* when set.
const fastResolvedInput = ref<string | null>(null);
const fastResolvedOutput = ref<string | null>(null);
// AI prompt suggestions for the Output/Prompt field (best-effort, shown as clickable chips).
const promptSuggestions = ref<string[]>([]);
const isLoadingSuggestions = ref(false);
const lastSuggestedInput = ref<string>("");
// Tracks whether the post-generation validation simulate has actually begun.
// Gates the isValidating reset so the "Validating..." label is not wiped by the
// isStepChanged / refreshKey churn that happens during the save (before simulate).
const validationStarted = ref(false);
const componentId = ref<string>(""); // Unique ID for THIS component instance

const TRANSFORMATION_BEFORE_BUTTON_KEYS = [
  "OPTIONS#x-oneteg-transformation-input",
  "OPTIONS#Output Data Structure",
];

function getTransformationSchemaBeforeButton(schema: any) {
  const properties: Record<string, any> = {};
  TRANSFORMATION_BEFORE_BUTTON_KEYS.forEach((key) => {
    if (schema.properties[key]) {
      properties[key] = schema.properties[key];
    }
  });
  const result = { ...schema, properties };
  if (result.required) {
    result.required = result.required.filter((r: string) =>
      TRANSFORMATION_BEFORE_BUTTON_KEYS.includes(r)
    );
  }
  return result;
}

function getTransformationSchemaAfterButton(schema: any) {
  const properties: Record<string, any> = {};
  if (schema.properties[TRANSFORMATION_SPEC_KEY]) {
    properties[TRANSFORMATION_SPEC_KEY] =
      schema.properties[TRANSFORMATION_SPEC_KEY];
  }
  const result = { ...schema, properties };
  if (result.required) {
    result.required = result.required.filter(
      (r: string) => r === TRANSFORMATION_SPEC_KEY
    );
  }
  return result;
}

const renameTooltipFieldsInSchema = (schema) => {
  Object.values(schema.properties).forEach(renameTooltipFieldsInProperty);
  return schema;
};

const renameTooltipFieldsInProperty = (property) => {
  if ("tooltip" in property) {
    property.description = property.tooltip;
    delete property.tooltip;
    if ("items" in property) {
      renameTooltipFieldsInProperty(property.items);
    }
  }
};

const { t } = i18n.global;
const preferOrigIdOutputReferences = inject(
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
  true
);

const ajv = createAjv({ useDefaults: true });

const emit = __emit;

const props = __props;

const isTransformationConnector = computed(() => {
  return (
    props.connectorSpecId?.toLowerCase().includes("transformation") ?? false
  );
});

const needsSimulation = computed(() => EventBus.isAnyChange);

// Only the root view knows the connector type; nested views inherit it from here.
if (props.childCount === 0) {
  provide(
    ARRAY_INJECTION_ENABLED_KEY,
    computed(() => !!props.connectorIsSwagger)
  );
}

watch(
  [
    () => props.simulationDataRefreshKey,
    () => props.isSimulating,
    () => props.isStepChanged,
  ],
  ([newKey, newSimulating], [oldKey, oldSimulating]) => {
    // Arm the resume gate when the silent simulation we initiated actually
    // starts (isSimulating false → true), OR when the legacy refresh-key
    // signal bumps. We must wait until simulation finishes before resuming.
    if (joltState.pendingGenerate && newSimulating && !oldSimulating) {
      joltState.pendingResume = true;
    }
    if (newKey !== oldKey && joltState.pendingGenerate) {
      joltState.pendingResume = true;
    }
    // Only resume after simulationDataRefreshKey bumps — that fires after
    // updateEditFlow() resolves, so transformedOutput/transformedPrompt props
    // are current. Triggering on isSimulating=false alone is too early: the
    // step data (and therefore the transformed props) hasn't been refreshed yet.
    if (
      joltState.pendingResume &&
      joltState.pendingGenerate &&
      !newSimulating &&
      !isGeneratingJolt.value &&
      newKey !== oldKey
    ) {
      joltState.pendingResume = false;
      joltState.pendingGenerate = false;
      clearPendingGenerateSafety();
      handleGenerateWithAI(true);
    }
    // Mark that the validation simulate has actually started.
    if (isValidating.value && newSimulating) {
      validationStarted.value = true;
    }
    // Only clear "Validating..." once that simulate has started AND finished —
    // not during the pre-simulate save churn.
    if (isValidating.value && validationStarted.value && !newSimulating) {
      isValidating.value = false;
      validationStarted.value = false;
    }
  }
);

const bodyMap = ref(new Map());

const selectedBodies = ref([]);

const injectedKeyList = ref([]);

const bodyColors = ref(
  getPreferenceValue("accordionColors")
    ? getPreferenceValue("accordionColors")
    : [
        "#C0DEFF",
        "#ADA2FF",
        "#BCCEF8",
        "#ECC5FB",
        "#E5E0FF",
        "#CAB8FF",
        "#DEEDF0",
        "#F6DFEB",
        "#E3F6FF",
        "#C780FA",
      ]
);

function addAlpha(color, opacity) {
  // coerce values so ti is between 0 and 1.
  const calcOpacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + calcOpacity.toString(16).toUpperCase();
}

function toggleAccordion(name, childCount, index) {
  const accordionId = `accordion-${filterSpecialCharacters(
    name
  )}-${childCount}-${index}-${index}`;
  const accordionElement = document.getElementById(accordionId);

  if (accordionElement && accordionElement.classList.contains("show")) {
    accordionElement.classList.remove("show");
  } else {
    accordionElement.classList.add("show");
  }

  emit("update-show-custom-request-body");
}

function getFieldValue(fieldKey: string): string {
  let result = "";
  Array.from(bodyMap.value.entries()).some(([, value]) => {
    const found = value.values.find(
      (val: any) => val.data && val.data[fieldKey]
    );
    if (found) {
      result = found.data[fieldKey];
      return true;
    }
    return false;
  });
  return result;
}

function setFieldValue(fieldKey: string, fieldValue: string): void {
  Array.from(bodyMap.value.entries()).some(([key, value]) => {
    const foundIndex = value.values.findIndex(
      (val: any) => val.schema?.properties && fieldKey in val.schema.properties
    );
    if (foundIndex !== -1) {
      const formattedValue = JSON.stringify([
        { name: fieldValue, type: "input", function: "" },
      ]);
      const newData = {
        ...(value.values[foundIndex].data || {}),
        [fieldKey]: formattedValue,
      };
      const newValues = [...value.values];
      newValues[foundIndex] = { ...newValues[foundIndex], data: newData };
      const newValue = { ...value, values: newValues };
      bodyMap.value.set(key, newValue);
      emit("update-data", bodyMap.value);
      emit("on-input-change", true);
      return true;
    }
    return false;
  });
}

let joltTimeoutId: ReturnType<typeof setTimeout> | null = null;

function clearJoltTimeout() {
  if (joltTimeoutId !== null) {
    clearTimeout(joltTimeoutId);
    joltTimeoutId = null;
  }
}

// Safety net for the "pendingGenerate" window (save → analyze → resume into
// generate). The button is disabled for this whole window, including the brief
// gap between the analyze finishing and generation starting. If the analyze
// step fails and never resumes, clear the pending flag so the button recovers
// instead of staying disabled.
let pendingGenerateTimeoutId: ReturnType<typeof setTimeout> | null = null;

function clearPendingGenerateSafety() {
  if (pendingGenerateTimeoutId !== null) {
    clearTimeout(pendingGenerateTimeoutId);
    pendingGenerateTimeoutId = null;
  }
}

function armPendingGenerateSafety() {
  clearPendingGenerateSafety();
  pendingGenerateTimeoutId = setTimeout(() => {
    if (joltState.pendingGenerate && !isGeneratingJolt.value) {
      joltState.pendingGenerate = false;
      joltState.pendingResume = false;
    }
  }, 30000);
}

function clearJoltPolling() {
  if (joltState.pollingTimeoutId !== null) {
    clearTimeout(joltState.pollingTimeoutId);
    joltState.pollingTimeoutId = null;
  }
}

function cleanupJoltSubscription() {
  clearJoltTimeout();
  clearJoltPolling();
  if (joltState.joltSubscription) {
    try {
      joltState.joltSubscription.unsubscribe();
    } catch {
      // Ignore unsubscribe errors
    }
    joltState.joltSubscription = null;
  }
  joltState.currentTransformationId = null;
  joltState.pendingTransformationLookup = false;
  joltState.messageBuffer.splice(0);
}

function cleanupJoltClient() {
  cleanupJoltSubscription();
  if (joltState.joltClient && joltState.joltClient.connected) {
    try {
      joltState.joltClient.disconnect();
    } catch {
      // Ignore disconnect errors
    }
  }
  joltState.joltClient = null;
}

let joltWsReconnectAttempts = 0;

function preConnectJoltWebSocket(): Promise<void> {
  if (joltState.joltClient?.connected) return Promise.resolve();
  return connectWebsocket().then(
    (stompClient) =>
      new Promise<void>((resolve, reject) => {
        joltState.joltClient = stompClient;
        stompClient.debug = (f) => f;
        stompClient.connect(
          {},
          () => resolve(),
          (err) => reject(err)
        );
      })
  );
}

function connectAndSubscribe(
  myComponentId: string,
  subscribeToTopic: () => void
) {
  if (joltState.joltClient?.connected) {
    joltWsReconnectAttempts = 0;
    subscribeToTopic();
    return;
  }

  connectWebsocket()
    .then((stompClient) => {
      joltState.joltClient = stompClient;
      stompClient.debug = (f) => f;

      joltState.joltClient.connect(
        {},
        () => {
          joltWsReconnectAttempts = 0;
          subscribeToTopic();
        },
        (error) => {
          console.error("[JOLT WS] Connection error:", error);
          handleJoltWsDisconnect(myComponentId, subscribeToTopic);
        }
      );
    })
    .catch((error) => {
      console.error("[JOLT WS] connectWebsocket error:", error);
      handleJoltWsDisconnect(myComponentId, subscribeToTopic);
    });
}

function handleJoltWsDisconnect(
  myComponentId: string,
  subscribeToTopic: () => void
) {
  if (
    !joltState.isJoltOperationInProgress ||
    joltWsReconnectAttempts >= JOLT_WS_MAX_RECONNECT_ATTEMPTS
  ) {
    joltState.isJoltOperationInProgress = false;
    if (joltState.activeComponentId === myComponentId) {
      isGeneratingJolt.value = false;
    }
    showAlert(TYPE.ERROR, t("Flow.WebSocketConnectionFailed"));
    joltWsReconnectAttempts = 0;
    return;
  }

  joltWsReconnectAttempts++;
  console.warn(
    `[JOLT WS] Reconnecting (attempt ${joltWsReconnectAttempts}/${JOLT_WS_MAX_RECONNECT_ATTEMPTS})...`
  );
  joltState.joltClient = null;

  setTimeout(() => {
    if (joltState.isJoltOperationInProgress) {
      connectAndSubscribe(myComponentId, subscribeToTopic);
    }
  }, JOLT_WS_RECONNECT_DELAY_MS);
}

function handleJoltMessage(data: any, myComponentId: string) {
  const isIntermediateStep = data.step && data.step !== "final";

  if (data.status === "processing" || data.status === "in_progress") {
    // Processing — nothing to do here.
    return;
  }

  if (
    (data.status === "completed" || data.status === "failed") &&
    !joltState.isJoltOperationInProgress &&
    joltState.currentTransformationId === null
  ) {
    // Already settled by an earlier WS or polling callback for this id.
    return;
  }

  if (data.status === "completed" && !isIntermediateStep) {
    joltState.isJoltOperationInProgress = false;

    const joltSpec = data.joltSpecification || data.jolt_specification;

    if (joltSpec) {
      const joltSpecString =
        typeof joltSpec === "string" ? joltSpec : JSON.stringify(joltSpec);

      pendingJoltResult.value = { joltSpec: joltSpecString };

      if (joltState.activeComponentId === myComponentId) {
        setFieldValue("OPTIONS#x-oneteg-transformation-spec", joltSpecString);
        isGeneratingJolt.value = false;
        pendingJoltResult.value = null;

        emit("save-after-spec", { autoValidate: autoValidateEnabled.value });
        if (autoValidateEnabled.value) {
          isValidating.value = true;
          validationStarted.value = false;
          // Safety: if the post-spec save fails and the validation simulate never
          // starts, clear the state so the button does not stay stuck.
          setTimeout(() => {
            if (isValidating.value && !validationStarted.value) {
              isValidating.value = false;
            }
          }, 15000);
        }
      }
      showAlert(
        TYPE.SUCCESS,
        t("Flow.JoltSpecGenerated") ||
          "JOLT specification generated successfully"
      );
    }
    cleanupJoltSubscription();
  } else if (data.status === "failed") {
    joltState.isJoltOperationInProgress = false;
    if (joltState.activeComponentId === myComponentId) {
      isGeneratingJolt.value = false;
      isValidating.value = false;
    }

    showAlert(
      TYPE.ERROR,
      data.processLog ||
        t("Flow.JoltGenerationFailed") ||
        "Failed to generate JOLT specification"
    );
    cleanupJoltSubscription();
  }
}

function subscribeJoltTopic(myComponentId: string) {
  if (!joltState.joltClient) return;

  if (joltState.joltSubscription) {
    try {
      joltState.joltSubscription.unsubscribe();
    } catch {
      // Ignore unsubscribe errors
    }
    joltState.joltSubscription = null;
  }

  const joltTopic = WebsocketUrlProvider.JoltTopic();

  joltState.joltSubscription = joltState.joltClient.subscribe(
    joltTopic,
    (msg) => {
      try {
        if (!msg.body) return;
        const data = JSON.parse(msg.body);
        const msgTransformationId =
          data.transformationId || data.transformation_id;

        if (!joltState.currentTransformationId) {
          // POST has not resolved yet — buffer for retroactive routing.
          pushJoltMessageToBuffer(data);
          return;
        }

        if (msgTransformationId !== joltState.currentTransformationId) {
          return;
        }

        handleJoltMessage(data, myComponentId);
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    }
  );
}

function beginJoltSubscription(myComponentId: string) {
  joltState.pendingTransformationLookup = true;
  joltWsReconnectAttempts = 0;

  if (!joltState.joltClient || !joltState.joltClient.connected) {
    connectAndSubscribe(myComponentId, () => subscribeJoltTopic(myComponentId));
  } else {
    subscribeJoltTopic(myComponentId);
  }
}

async function pollJoltResult(transformationId: string, myComponentId: string) {
  if (joltState.currentTransformationId !== transformationId) return;
  try {
    const result = await getJoltTransformationResult(transformationId);
    if (!result) return;
    if (joltState.currentTransformationId !== transformationId) return;

    if (result.status === "completed" && result.joltSpec) {
      handleJoltMessage(
        {
          status: "completed",
          transformationId,
          joltSpecification: result.joltSpec,
        },
        myComponentId
      );
    } else if (result.status === "failed") {
      handleJoltMessage(
        {
          status: "failed",
          transformationId,
          processLog: result.errorMessage,
        },
        myComponentId
      );
    }
  } catch (error) {
    console.error("[JOLT] polling fallback error:", error);
  }
}

function attachTransformationId(
  transformationId: string,
  myComponentId: string,
  timeoutSeconds = 150
) {
  if (!transformationId) return;

  joltState.currentTransformationId = transformationId;
  joltState.pendingTransformationLookup = false;

  // Drain any messages received before the POST resolved.
  if (joltState.messageBuffer.length > 0) {
    const buffered = joltState.messageBuffer.splice(0);
    const settled = buffered.some((data) => {
      const msgId = data.transformationId || data.transformation_id;
      if (msgId === transformationId) {
        handleJoltMessage(data, myComponentId);
        if (!joltState.isJoltOperationInProgress) return true;
      }
      return false;
    });
    if (settled) return;
  }

  clearJoltTimeout();
  joltTimeoutId = setTimeout(() => {
    joltState.isJoltOperationInProgress = false;
    if (joltState.activeComponentId === myComponentId) {
      isGeneratingJolt.value = false;
    }
    cleanupJoltSubscription();
    showAlert(
      TYPE.ERROR,
      t("Flow.JoltTimeout") ||
        "Transformation timed out. Your prompt may not be valid, please try with a different one."
    );
  }, (timeoutSeconds + 10) * 1000);

  clearJoltPolling();
  joltState.pollingTimeoutId = setTimeout(() => {
    pollJoltResult(transformationId, myComponentId);
  }, JOLT_POLLING_FALLBACK_MS);
}

// Build the cached-output context for fast-resolve, keyed by the same index the stored
// references use (item.index). A wrong/missing key only causes a safe backend fallback to
// full simulation — never wrong data.
function buildCachedStepOutputs(): Record<string, unknown> {
  const cached: Record<string, unknown> = {};
  (props.outputList || []).forEach((item: any) => {
    if (item?.output != null && item?.index != null) {
      cached[String(item.index)] = item.output;
    }
  });
  return cached;
}

// Try to resolve the transformation fields from cached outputs instead of simulating.
// Returns true on success (local resolved refs are populated); false means fall back.
async function tryFastResolve(): Promise<boolean> {
  try {
    const inputField = getFieldValue("OPTIONS#x-oneteg-transformation-input");
    // A blank input field means the reference lives elsewhere (e.g. an injected-parent set via
    // the inject button) or the field is genuinely empty — let the full simulate handle it so we
    // never generate against empty/wrong input.
    if (!inputField || !String(inputField).trim()) {
      return false;
    }
    const result = await resolveJoltFields({
      inputField,
      outputField: getFieldValue("OPTIONS#Output Data Structure"),
      cachedStepOutputs: buildCachedStepOutputs(),
      userDefinedVariables: JSON.stringify(props.userDefinedVariables ?? []),
    });
    if (result.fallbackRequired) return false;
    fastResolvedInput.value = result.resolvedInput ?? null;
    fastResolvedOutput.value =
      result.resolvedOutput ?? result.resolvedPrompt ?? null;
    return true;
  } catch {
    return false;
  }
}

// Fired when focus leaves the transformation input/output block. If the input field changed
// since the last request, fetch fresh Output/Prompt suggestions for it.
function onTransformationBlur() {
  if (!aiJoltEnabled.value) return;
  const input = getFieldValue("OPTIONS#x-oneteg-transformation-input");
  const trimmed = input ? String(input).trim() : "";
  if (!trimmed) {
    promptSuggestions.value = [];
    lastSuggestedInput.value = "";
    return;
  }
  if (trimmed === lastSuggestedInput.value || isLoadingSuggestions.value)
    return;
  fetchPromptSuggestions(input);
}

async function fetchPromptSuggestions(inputField: string) {
  lastSuggestedInput.value = String(inputField).trim();
  isLoadingSuggestions.value = true;
  promptSuggestions.value = [];
  try {
    const suggestions = await recommendPrompts({
      inputField,
      cachedStepOutputs: buildCachedStepOutputs(),
      userDefinedVariables: JSON.stringify(props.userDefinedVariables ?? []),
    });
    // Ignore if the input changed again while we were waiting.
    if (lastSuggestedInput.value === String(inputField).trim()) {
      promptSuggestions.value = suggestions.slice(0, 3);
    }
  } catch {
    // recommendPrompts is failure-safe, so this only guards rare synchronous
    // throws — clear the guard so the user can retry by blurring again.
    lastSuggestedInput.value = "";
  } finally {
    isLoadingSuggestions.value = false;
  }
}

function applyPromptSuggestion(suggestion: string) {
  setFieldValue("OPTIONS#Output Data Structure", suggestion);
  promptSuggestions.value = [];
}

async function handleGenerateWithAI(isResuming: boolean | Event = false) {
  if (isGeneratingJolt.value) {
    return;
  }

  if (props.isSimulating) {
    joltState.pendingGenerate = true;
    armPendingGenerateSafety();
    return;
  }

  if (props.isStepChanged && isResuming !== true) {
    joltState.pendingGenerate = true;
    armPendingGenerateSafety();
    // Prefer the lightweight resolve (no full simulation); fall back to simulate on any miss.
    if (fastResolveEnabled.value && (await tryFastResolve())) {
      joltState.pendingGenerate = false;
      clearPendingGenerateSafety();
      handleGenerateWithAI(true);
      return;
    }
    emit("simulate-for-spec", { silent: true, reason: "generate-spec" });
    return;
  }

  isGeneratingJolt.value = true;
  joltState.isJoltOperationInProgress = true;
  pendingJoltResult.value = null;
  const myComponentId = componentId.value;
  joltState.activeComponentId = myComponentId;

  try {
    const inputDataRaw = getFieldValue("OPTIONS#x-oneteg-transformation-input");
    const outputOrPromptRaw = getFieldValue("OPTIONS#Output Data Structure");

    const extractFieldValue = (raw: any): any => {
      if (!raw) return raw;
      let value = raw;
      if (typeof value === "string") {
        try {
          value = JSON.parse(value);
        } catch {
          return raw;
        }
      }
      if (
        Array.isArray(value) &&
        value.length > 0 &&
        value[0]?.name !== undefined
      ) {
        const nameValue = value.map((item: any) => item.name ?? "").join("");
        if (typeof nameValue === "string") {
          try {
            return JSON.parse(nameValue);
          } catch {
            return nameValue;
          }
        }
        return nameValue;
      }
      if (typeof value === "object" && value !== null && "name" in value) {
        const nameValue = value.name;
        if (typeof nameValue === "string") {
          try {
            return JSON.parse(nameValue);
          } catch {
            return nameValue;
          }
        }
        return nameValue;
      }
      return value;
    };

    // Capture and clear one-shot fast-resolve results (preferred over simulation props).
    const fastIn = fastResolvedInput.value;
    const fastOut = fastResolvedOutput.value;
    fastResolvedInput.value = null;
    fastResolvedOutput.value = null;

    // 1. Resolve Input Data
    let inputData: any = null;
    if (fastIn && fastIn !== "null") {
      try {
        inputData = JSON.parse(fastIn);
      } catch {
        inputData = fastIn;
      }
    } else if (props.transformedInput && props.transformedInput !== "null") {
      try {
        inputData = JSON.parse(props.transformedInput);
      } catch {
        inputData = props.transformedInput;
      }
    } else {
      inputData = extractFieldValue(inputDataRaw);
    }

    // 2. Resolve Unified Output/Prompt Data
    // The backend may put the resolved value in either transformedOutput or
    // transformedPrompt depending on content. Check both and prefer whichever
    // is set from the latest simulation. If neither, fall back to the raw field.
    let unifiedData: any = null;
    const hasTransformedOutput =
      props.transformedOutput && props.transformedOutput !== "null";
    const hasTransformedPrompt =
      props.transformedPrompt && props.transformedPrompt !== "null";

    if (fastOut && fastOut !== "null") {
      try {
        unifiedData = JSON.parse(fastOut);
      } catch {
        unifiedData = fastOut;
      }
    } else if (hasTransformedOutput || hasTransformedPrompt) {
      const rawResolved = hasTransformedOutput
        ? props.transformedOutput
        : props.transformedPrompt;
      try {
        unifiedData = JSON.parse(rawResolved!);
      } catch {
        unifiedData = rawResolved;
      }
    } else {
      unifiedData = extractFieldValue(outputOrPromptRaw);
    }

    // 3. Detect if the unified data is JSON Structure or Prompt String
    let outputDataStructure: any;
    let context: any;

    if (typeof unifiedData === "object" && unifiedData !== null) {
      outputDataStructure = unifiedData;
    } else if (typeof unifiedData === "string" && unifiedData.trim()) {
      try {
        const parsed = JSON.parse(unifiedData);
        if (typeof parsed === "object" && parsed !== null) {
          outputDataStructure = parsed;
        } else {
          context = unifiedData;
        }
      } catch {
        context = unifiedData;
      }
    }

    const isFieldEmpty = (val: any): boolean => {
      if (!val) return true;
      if (typeof val === "string") return !val.trim();
      if (Array.isArray(val)) return val.length === 0;
      if (typeof val === "object") return Object.keys(val).length === 0;
      return false;
    };

    if (isFieldEmpty(inputData)) {
      showAlert(
        TYPE.WARNING,
        t("Flow.InputDataRequired") || "Input Data is required"
      );
      isGeneratingJolt.value = false;
      joltState.isJoltOperationInProgress = false;
      return;
    }

    if (typeof inputData === "string") {
      try {
        JSON.parse(inputData);
      } catch {
        showAlert(
          TYPE.WARNING,
          t("Flow.JoltInvalidInputData") ||
            "The Input Data is not a valid JSON format."
        );
        isGeneratingJolt.value = false;
        joltState.isJoltOperationInProgress = false;
        return;
      }
    }

    if (isFieldEmpty(outputDataStructure) && isFieldEmpty(context)) {
      showAlert(
        TYPE.WARNING,
        t("Flow.OutputOrPromptRequired") ||
          "Either Output Data Structure or Prompt must be provided"
      );
      isGeneratingJolt.value = false;
      joltState.isJoltOperationInProgress = false;
      return;
    }

    try {
      await preConnectJoltWebSocket();
    } catch {
      showAlert(TYPE.ERROR, t("Flow.WebSocketConnectionFailed"));
      isGeneratingJolt.value = false;
      joltState.isJoltOperationInProgress = false;
      return;
    }

    // Subscribe BEFORE POST so any backend message that arrives during the
    // POST round-trip is buffered and routed once the transformationId is known.
    beginJoltSubscription(myComponentId);

    showAlert(
      TYPE.INFO,
      t("Flow.GeneratingJoltSpec") || "Generating JOLT specification..."
    );

    const response = await generateJoltTransformation({
      inputData,
      outputData: outputDataStructure,
      context,
    });

    if (response?.status === "processing" && response.transformationId) {
      attachTransformationId(
        response.transformationId,
        myComponentId,
        response.timeoutSeconds ?? 150
      );
    } else if (response?.error) {
      showAlert(TYPE.ERROR, response.error);
      isGeneratingJolt.value = false;
      joltState.isJoltOperationInProgress = false;
      cleanupJoltSubscription();
    } else {
      showAlert(
        TYPE.ERROR,
        t("Flow.JoltGenerationFailed") ||
          "Failed to generate JOLT specification"
      );
      isGeneratingJolt.value = false;
      joltState.isJoltOperationInProgress = false;
      cleanupJoltSubscription();
    }
  } catch (error: any) {
    console.error("JOLT generation error:", error);
    showAlert(
      TYPE.ERROR,
      error.message ||
        t("Flow.JoltGenerationError") ||
        "An error occurred during JOLT generation"
    );
    isGeneratingJolt.value = false;
    joltState.isJoltOperationInProgress = false;
    cleanupJoltSubscription();
  }
}

function filterSpecialCharacters(str) {
  return str.replaceAll(/[^a-zA-Z]/g, "");
}
function handleClickEvent(isDrawerOpen, controlId) {
  emit("handle-click-event", isDrawerOpen, controlId);
}
function expressionDrawer(drawerStatus) {
  emit("expression-drawer", drawerStatus);
}
function onInputChange() {
  emit("on-input-change", true);
}
function onBodyChange(event, key, index) {
  if (bodyMap.value.has(key)) {
    const object = bodyMap.value.get(key);
    const copy = object.values[index];
    if (event.data.type) {
      if (event.data.type === "dateTime") {
        copy.schema.properties.value.format = "date";
      } else {
        copy.schema.properties.value.format = undefined;
      }
    }
    if (isTransformationConnector.value) {
      // Merge: keep fields from the other JsonForms instance
      const mergedData = { ...copy.data, ...event.data };
      // Remove legacy Prompt field — it was removed from the schema but may still
      // exist in old saved flows. Stripping it prevents stale data from being
      // simulated and appearing in connector output.
      delete mergedData["OPTIONS#Prompt"];
      if (isEqual(copy.data, mergedData)) return; // guard: skip if data unchanged
      copy.data = mergedData;
    } else {
      copy.data = event.data;
    }
    object.values.splice(index, 1, copy);
    bodyMap.value.set(key, object);
  }
  emit("update-data", bodyMap.value);
}

function updateData(event, key, value, index?) {
  if (bodyMap.value.has(key)) {
    const object = bodyMap.value.get(key);
    const copy = object.values[index];
    copy.children = event;
    object.values.splice(index, 1, copy);
    bodyMap.value.set(key, object);
  }
  emit("update-data", bodyMap.value);
}

function removeBodyElement(oldList, newList) {
  if (newList.length < oldList.length) {
    const dif = oldList.filter((mapData) => !newList.includes(mapData));
    dif.forEach((key) => {
      bodyMap.value.delete(key);
    });
  }
}

function addNewBodyItem(key) {
  if (bodyMap.value.size !== 0) {
    const value = bodyMap.value.get(key);
    const index = props.requestBodies.findIndex(
      (bodyData) => bodyData.name === key
    );
    const body = props.requestBodies[index];
    value.values.push({
      name: body.name,
      path: body.path,
      description: body.description,
      bodyRequestType: body.bodyRequestType,
      schema: cloneDeep(body.schema),
      childrenBodies: body.children,
      children: {},
      dataType: body.dataType,
      data: {},
    });
    bodyMap.value.set(key, value);
  }
}

function removeBodyItem(key: string, index: number) {
  if (bodyMap.value.size !== 0) {
    const value = bodyMap.value.get(key);
    value.values.splice(index, 1);
    if (value.values.length === 0) {
      bodyMap.value.delete(key);
      selectedBodies.value.splice(selectedBodies.value.indexOf(key), 1);
    } else {
      bodyMap.value.set(key, value);
    }
  }
  emit("update-data", bodyMap.value);
}

watch(
  () => props.existingData,
  () => {
    if (isEmpty(props.existingData)) {
      bodyMap.value = new Map();
      selectedBodies.value = [];
    }
  }
);

watch(
  () => selectedBodies.value,
  (newValue, oldValue) => {
    if (propsSet) {
      selectedBodies.value.forEach((val) => {
        const index = props.requestBodies.findIndex(
          (bodyData: any) => bodyData.name === val
        );
        if (index !== -1 && !bodyMap.value.has(val)) {
          const body = props.requestBodies[index];
          bodyMap.value.set(body.name, {
            dataType: body.dataType,
            values: [
              {
                name: body.name,
                path: body.path,
                description: body.description,
                bodyRequestType: body.bodyRequestType,
                schema: cloneDeep(body.schema),
                childrenBodies: body.children,
                children: {},
                dataType: body.dataType,
                data: {},
              },
            ],
          });
        }
      });
    }
    removeBodyElement(oldValue, newValue);
    emit("update-data", bodyMap.value);
  },
  { deep: true }
);

watch(
  () => pendingJoltResult.value,
  (newResult) => {
    if (newResult && isTransformationConnector.value) {
      nextTick(() => {
        setFieldValue(
          "OPTIONS#x-oneteg-transformation-spec",
          newResult.joltSpec
        );
        pendingJoltResult.value = null;
        joltState.isJoltOperationInProgress = false;
        isGeneratingJolt.value = false;
      });
    }
  }
);

watch(
  () => joltState.isJoltOperationInProgress,
  (inProgress) => {
    if (!inProgress) {
      isGeneratingJolt.value = false;
    }
  }
);

let propsSet = false;
onBeforeMount(() => {
  // Generate a unique ID for this component instance
  componentId.value = `${Date.now()}-${Math.random()
    .toString(36)
    .substr(2, 9)}`;
  if (props.existingData && !isEmpty(props.existingData)) {
    bodyMap.value = cloneDeep(props.existingData);
    bodyMap.value.forEach((_value, key) => {
      selectedBodies.value.push(key);
    });
  }
  propsSet = true;
  if (props.childCount === 0 && selectedBodies.value.length === 0) {
    const selectedBody = props.requestBodies[0];
    selectedBodies.value.push(selectedBody.name);
  }
});

onMounted(() => {
  // Check if AI JOLT feature is enabled for the tenant
  const tenantId = authInfo.value?.tenantId;
  if (tenantId) {
    isAIJoltEnabledForTenant(tenantId).then((enabled) => {
      aiJoltEnabled.value = enabled;
    });
    isAIJoltAutoValidateEnabled().then((enabled) => {
      autoValidateEnabled.value = enabled;
    });
    isAIJoltFastResolveEnabled().then((enabled) => {
      fastResolveEnabled.value = enabled;
    });
  }

  // Check if there's a pending JOLT result from a previous component instance
  if (isTransformationConnector.value && pendingJoltResult.value) {
    // Use nextTick to ensure the form is fully rendered
    nextTick(() => {
      if (pendingJoltResult.value) {
        setFieldValue(
          "OPTIONS#x-oneteg-transformation-spec",
          pendingJoltResult.value.joltSpec
        );
        pendingJoltResult.value = null;
        joltState.isJoltOperationInProgress = false;
        isGeneratingJolt.value = false;
      }
    });
  }

  if (isTransformationConnector.value && joltState.isJoltOperationInProgress) {
    isGeneratingJolt.value = true;
    if (
      !joltState.activeComponentId ||
      joltState.activeComponentId === componentId.value
    ) {
      joltState.activeComponentId = componentId.value;
    }
  }
});

onBeforeUnmount(() => {
  clearPendingGenerateSafety();
  if (joltState.isJoltOperationInProgress) {
    if (joltState.activeComponentId === componentId.value) {
      joltState.activeComponentId = null;
    }
    return;
  }
  if (joltState.activeComponentId === componentId.value) {
    cleanupJoltClient();
    joltState.activeComponentId = null;
  }
});

async function showOutputDrawer(key) {
  if (props.objectInjectionModalVisibleKey !== key) {
    handleClickEvent(false, props.objectInjectionModalVisibleKey);
  }

  emit("change-object-injection-modal-visible-key", key);

  handleClickEvent(true, key);
}
function addUserVariable(e, key, val, index, drawerKey, buttonKey) {
  if (bodyMap.value.has(key)) {
    const object = bodyMap.value.get(key);
    const copy = object.values[index];
    copy.data[`${copy.path}#oneteg_injected_parent`] = JSON.stringify([
      {
        name: e.name,
        type: "user-defined-variable",
        function: "",
      },
    ]);
    object.values.splice(index, 1, copy);
    bodyMap.value.set(key, object);
  }
  emit("update-data", bodyMap.value);
  handleClickEvent(false, drawerKey);
  emit("change-object-injection-modal-visible-key", "");
  const buttonElement: HTMLButtonElement = document.querySelector(
    `[data-bs-target="${buttonKey}"]`
  );
  if (
    buttonElement &&
    !buttonElement.getAttribute("class").includes("collapsed")
  ) {
    buttonElement.click();
  }

  injectedKeyList.value.push(`${key}-${val.path || val.name}-${index}`);
}

function addOutput(e, key, val, index, drawerKey, buttonKey) {
  if (bodyMap.value.has(key)) {
    const object = bodyMap.value.get(key);
    const copy = object.values[index];
    copy.data[`${copy.path}#oneteg_injected_parent`] = JSON.stringify([
      {
        name: e.name,
        type: "output",
        function: "",
      },
    ]);
    object.values.splice(index, 1, copy);
    bodyMap.value.set(key, object);
  }
  emit("update-data", bodyMap.value);
  handleClickEvent(false, drawerKey);
  emit("change-object-injection-modal-visible-key", "");
  const buttonElement: HTMLButtonElement = document.querySelector(
    `[data-bs-target="${buttonKey}"]`
  );
  if (
    buttonElement &&
    !buttonElement.getAttribute("class").includes("collapsed")
  ) {
    buttonElement.click();
  }

  injectedKeyList.value.push(`${key}-${val.path || val.name}-${index}`);
}

function addMetaoutput(e, key, val, index, drawerKey, buttonKey) {
  if (bodyMap.value.has(key)) {
    const object = bodyMap.value.get(key);
    const copy = object.values[index];
    let name = e.name.split("/");
    name = name[name.length - 1];
    copy.data[`${copy.path}#oneteg_injected_parent`] = JSON.stringify([
      {
        name: `/metaoutput/#ix-${e.stepIndex}@${name}`,
        type: "metaoutput",
        function: "",
      },
    ]);
    object.values.splice(index, 1, copy);
    bodyMap.value.set(key, object);
  }
  emit("update-data", bodyMap.value);
  handleClickEvent(false, drawerKey);
  emit("change-object-injection-modal-visible-key", "");
  const buttonElement: HTMLButtonElement = document.querySelector(
    `[data-bs-target="${buttonKey}"]`
  );
  if (
    buttonElement &&
    !buttonElement.getAttribute("class").includes("collapsed")
  ) {
    buttonElement.click();
  }

  injectedKeyList.value.push(`${key}-${val.path || val.name}-${index}`);
}

function getInjectedVariable(key) {
  if (!bodyMap.value.has(key)) {
    return "";
  }
  const currentValue = bodyMap.value.get(key).values?.[0];

  const getDisplayIndex = (type: "output" | "metaoutput", index: number) => {
    const list = type === "output" ? props.outputList : props.metaoutput;
    const matched = Array.isArray(list)
      ? list.find((item: any) => item?.index === index)
      : null;

    if (typeof matched?.stepNumber === "number" && matched.stepNumber > 0) {
      return matched.stepNumber;
    }

    return preferOrigIdOutputReferences ? index : index + 1;
  };

  try {
    const parsedData = JSON.parse(
      currentValue?.data?.[`${currentValue.path}#oneteg_injected_parent`]
    );
    const [firstItem] = parsedData;

    if (firstItem.type === "metaoutput") {
      const { name } = firstItem;
      const index = parseMetaoutputIndexFromName(name);
      const rawPath = name.match(/^\/metaoutput\/#ix-\d+@(.+)$/)?.[1] || "";
      if (index === null) {
        return "";
      }
      return `${getDisplayIndex("metaoutput", index)}./${rawPath
        .replace(/^#/, "")
        .replace(/@#/g, "/")}`;
    }
    const { name } = firstItem;
    const index = parseOutputIndexFromName(name);
    if (index === null) {
      return "";
    }
    return name.replace(/^\/\d+\//, `/${getDisplayIndex("output", index)}/`);
  } catch (e) {
    return "";
  }
}

function removeInjectedVariable($event, key, val, index, buttonKey) {
  if (bodyMap.value.has(key)) {
    const object = bodyMap.value.get(key);
    const copy = object.values[0];
    object.values[0].data = omit(
      copy.data,
      `${copy.path}#oneteg_injected_parent`
    );
  }

  injectedKeyList.value = injectedKeyList.value.filter(
    (x) => x !== `${key}-${val.path || val.name}-${index}`
  );

  nextTick(() => {
    const buttonElement: HTMLButtonElement = document.querySelector(
      `[data-bs-target="${buttonKey}"]`
    );
    if (buttonElement) {
      buttonElement.click();
    }
  });

  emit("update-data", bodyMap.value);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RequestBodyView = _resolveComponent("RequestBodyView", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElSelect), {
      modelValue: selectedBodies.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedBodies).value = $event)),
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      id: "flow-body-select",
      size: "small",
      class: "width-100",
      placeholder: _unref(t)('Flow.SelectListItems')
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestBodies, (body, index) => {
          return (_openBlock(), _createBlock(_unref(ElOption), {
            key: body.name,
            id: 'flow-body-option-' + index,
            value: body.name,
            label: body.description
          }, null, 8, ["id", "value", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bodyMap.value, ([key, value]) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "margin-top-10"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.values, (val, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: val,
            class: _normalizeClass(["d-flex flex-row", { 'margin-top-10': index > 0 }])
          }, [
            _createElementVNode("div", {
              class: "accordion width-100",
              style: _normalizeStyle({
          'border-left': `3px ${
            injectedKeyList.value.includes(`${key}-${val.path || val.name}-${index}`)
              ? 'rgb(227, 227, 227)'
              : bodyColors.value[_ctx.childCount % 10]
          } solid !important`,
        }),
              id: `accordion-${filterSpecialCharacters(
          val.name
        )}-${_ctx.childCount}-${index}`
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h2", {
                  class: "accordion-header d-flex max-height-40 d-flex align-items-center justify-content-center",
                  style: _normalizeStyle({
              'background-color': `${
                injectedKeyList.value.includes(
                  `${key}-${val.path || val.name}-${index}`
                )
                  ? 'rgb(227, 227, 227)'
                  : bodyColors.value[_ctx.childCount % 10]
              }!important`,
            }),
                  id: `heading-${filterSpecialCharacters(
              val.name
            )}-${_ctx.childCount}-${index}`
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "accordion-button btn-accordion font-size-14 max-height-40",
                      type: "button",
                      style: _normalizeStyle({
                  'background-color': `${
                    injectedKeyList.value.includes(
                      `${key}-${val.path || val.name}-${index}`
                    )
                      ? 'rgb(227, 227, 227)'
                      : bodyColors.value[_ctx.childCount % 10]
                  }!important`,
                }),
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#accordion-${filterSpecialCharacters(
                  val.name
                )}-${_ctx.childCount}-${index}-${index}`,
                      "aria-expanded": "true",
                      "aria-controls": "collapseOne",
                      disabled: 
                  injectedKeyList.value.includes(
                    `${key}-${val.path || val.name}-${index}`
                  )
                
                    }, [
                      _createElementVNode("div", null, _toDisplayString(val.description), 1)
                    ], 12, _hoisted_5),
                    (getInjectedVariable(key))
                      ? (_openBlock(), _createBlock(_unref(ElTag), {
                          key: 0,
                          style: {"position":"absolute","right":"40px","top":"8px","z-index":"999"},
                          class: "mx-1",
                          size: "small",
                          type: "info",
                          closable: "",
                          onClose: _withModifiers(($event: any) => (
                  removeInjectedVariable(
                    $event,
                    key,
                    val,
                    index,
                    `#accordion-${filterSpecialCharacters(
                      val.name
                    )}-${_ctx.childCount}-${index}-${index}`
                  )
                ), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getInjectedVariable(key, value)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClose"]))
                      : _createCommentVNode("", true)
                  ]),
                  (value.dataType === 'ARRAY' || value.dataType === 'MAP')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-oneTeg max-height-32 d-flex align-items-center justify-content-center",
                        style: {"height":"32px"},
                        onClick: ($event: any) => (addNewBodyItem(key))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "plus",
                          size: "xs"
                        })
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (value.dataType === 'ARRAY' || value.dataType === 'MAP')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-oneTeg3 max-height-32 d-flex align-items-center justify-content-center",
                        style: {"height":"32px"},
                        onClick: ($event: any) => (removeBodyItem(key, index))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "trash",
                          size: "xs"
                        })
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (!getInjectedVariable(key))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-oneTeg3 max-height-32 d-flex align-items-center justify-content-center",
                        style: {"height":"32px"},
                        onClick: ($event: any) => (
                showOutputDrawer(`${key}-${val.path || val.name}-${index}`)
              )
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "database",
                          size: "xs"
                        })
                      ], 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (_ctx.connectorIsSwagger)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "btn btn-oneTeg3 max-height-32 d-flex align-items-center justify-content-center",
                        style: {"height":"32px"},
                        onClick: ($event: any) => (toggleAccordion(val.name, _ctx.childCount, index))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "pencil-alt",
                          size: "xs"
                        })
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ], 12, _hoisted_3),
                _createElementVNode("div", {
                  id: `accordion-${filterSpecialCharacters(
              val.name
            )}-${_ctx.childCount}-${index}-${index}`,
                  class: _normalizeClass(["accordion-collapse collapse", !getInjectedVariable(key) ? 'show' : '']),
                  "aria-labelledby": `heading-${filterSpecialCharacters(
              val.name
            )}-${_ctx.childCount}-${index}`,
                  "data-bs-parent": `#accordion-${filterSpecialCharacters(
              val.name
            )}-${_ctx.childCount}-${index}`
                }, [
                  _createElementVNode("div", {
                    class: "accordion-body border-0 p-10",
                    style: _normalizeStyle({
                'background-color': `${addAlpha(
                  bodyColors.value[_ctx.childCount % 10],
                  0.5
                )}!important`,
              })
                  }, [
                    (!isTransformationConnector.value)
                      ? (_openBlock(), _createBlock(_unref(JsonForms), {
                          key: `body-${key}-${index}`,
                          data: val.data,
                          renderers: _unref(renderers),
                          userDefinedVariables: _ctx.userDefinedVariables,
                          "system-variables": _ctx.systemVariables,
                          expressions: _ctx.expressions,
                          metaoutputList: _ctx.metaoutput,
                          onHandleClickEvent: handleClickEvent,
                          onExpressionDrawer: expressionDrawer,
                          schema: renameTooltipFieldsInSchema(val.schema),
                          ajv: _unref(ajv),
                          tab: true,
                          stepIdx: _ctx.stepIdx,
                          outputList: _ctx.outputList,
                          onChange: ($event: any) => (onBodyChange($event, key, index)),
                          onInput: onInputChange
                        }, null, 8, ["data", "renderers", "userDefinedVariables", "system-variables", "expressions", "metaoutputList", "schema", "ajv", "stepIdx", "outputList", "onChange"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", { onFocusout: onTransformationBlur }, [
                            (_openBlock(), _createBlock(_unref(JsonForms), {
                              key: `before-${key}-${index}`,
                              data: val.data,
                              renderers: _unref(renderers),
                              userDefinedVariables: _ctx.userDefinedVariables,
                              "system-variables": _ctx.systemVariables,
                              expressions: _ctx.expressions,
                              metaoutputList: _ctx.metaoutput,
                              onHandleClickEvent: handleClickEvent,
                              onExpressionDrawer: expressionDrawer,
                              schema: 
                      renameTooltipFieldsInSchema(
                        getTransformationSchemaBeforeButton(val.schema)
                      )
                    ,
                              ajv: _unref(ajv),
                              tab: true,
                              stepIdx: _ctx.stepIdx,
                              outputList: _ctx.outputList,
                              onChange: ($event: any) => (onBodyChange($event, key, index)),
                              onInput: onInputChange
                            }, null, 8, ["data", "renderers", "userDefinedVariables", "system-variables", "expressions", "metaoutputList", "schema", "ajv", "stepIdx", "outputList", "onChange"]))
                          ], 32),
                          (
                    aiJoltEnabled.value &&
                    (isLoadingSuggestions.value || promptSuggestions.value.length)
                  )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (isLoadingSuggestions.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "sync",
                                        size: "xs",
                                        spin: true
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.PromptSuggestionsLoading")), 1)
                                    ]))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(promptSuggestions.value, (suggestion, sIdx) => {
                                      return (_openBlock(), _createBlock(_unref(ElTag), {
                                        key: sIdx,
                                        size: "small",
                                        type: "info",
                                        style: {"cursor":"pointer"},
                                        onClick: ($event: any) => (applyPromptSuggestion(suggestion))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(suggestion), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (aiJoltEnabled.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_unref(ElTooltip), {
                                  content: _unref(t)('Flow.GenerateSpecTooltip'),
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("button", {
                                      class: "btn btn-oneTeg2 d-flex align-items-center justify-content-center",
                                      style: {"height":"32px","white-space":"nowrap","padding":"0 12px","font-size":"12px"},
                                      disabled: 
                        isGeneratingJolt.value ||
                        isValidating.value ||
                        _unref(joltState).pendingGenerate
                      ,
                                      onClick: handleGenerateWithAI
                                    }, [
                                      (
                          !isGeneratingJolt.value &&
                          !isValidating.value &&
                          !_unref(joltState).pendingGenerate
                        )
                                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                            key: 0,
                                            icon: "magic",
                                            size: "xs",
                                            style: {"margin-right":"5px"}
                                          }))
                                        : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                            key: 1,
                                            icon: "sync",
                                            size: "xs",
                                            style: {"margin-right":"5px"},
                                            spin: true
                                          })),
                                      _createTextVNode(" " + _toDisplayString(_unref(joltState).pendingGenerate && _ctx.isStepChanged
                          ? _unref(t)("Flow.SavingForGenerateSpec")
                          : _unref(joltState).pendingGenerate
                          ? _unref(t)("Flow.SimulatingForGenerateSpec")
                          : isGeneratingJolt.value
                          ? _unref(t)("Flow.Generating")
                          : isValidating.value
                          ? _unref(t)("Flow.ValidatingForGenerateSpec")
                          : _unref(t)("Flow.GenerateSpecWithAI")), 1)
                                    ], 8, _hoisted_14)
                                  ]),
                                  _: 1
                                }, 8, ["content"])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(), _createBlock(_unref(JsonForms), {
                            key: `after-${key}-${index}`,
                            data: val.data,
                            renderers: _unref(renderers),
                            userDefinedVariables: _ctx.userDefinedVariables,
                            "system-variables": _ctx.systemVariables,
                            expressions: _ctx.expressions,
                            metaoutputList: _ctx.metaoutput,
                            onHandleClickEvent: handleClickEvent,
                            onExpressionDrawer: expressionDrawer,
                            schema: 
                    renameTooltipFieldsInSchema(
                      getTransformationSchemaAfterButton(val.schema)
                    )
                  ,
                            ajv: _unref(ajv),
                            tab: true,
                            stepIdx: _ctx.stepIdx,
                            outputList: _ctx.outputList,
                            onChange: ($event: any) => (onBodyChange($event, key, index)),
                            onInput: onInputChange
                          }, null, 8, ["data", "renderers", "userDefinedVariables", "system-variables", "expressions", "metaoutputList", "schema", "ajv", "stepIdx", "outputList", "onChange"]))
                        ], 64)),
                    (val.childrenBodies)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_RequestBodyView, {
                            "request-bodies": val.childrenBodies,
                            "output-list": _ctx.outputList,
                            "user-defined-variables": _ctx.userDefinedVariables,
                            "system-variables": _ctx.systemVariables,
                            expressions: _ctx.expressions,
                            "step-idx": _ctx.stepIdx,
                            metaoutput: _ctx.metaoutput,
                            "existing-data": val.children,
                            "child-count": _ctx.childCount + 1,
                            "connector-spec-id": _ctx.connectorSpecId,
                            "transformed-input": _ctx.transformedInput,
                            "transformed-output": _ctx.transformedOutput,
                            "transformed-prompt": _ctx.transformedPrompt,
                            "is-step-changed": _ctx.isStepChanged,
                            "is-simulating": _ctx.isSimulating,
                            onSimulateForSpec: _cache[1] || (_cache[1] = ($event: any) => (emit('simulate-for-spec'))),
                            onHandleClickEvent: handleClickEvent,
                            onExpressionDrawer: expressionDrawer,
                            onUpdateData: ($event: any) => (updateData($event, key, val, index)),
                            objectInjectionModalVisibleKey: 
                    _ctx.objectInjectionModalVisibleKey
                  ,
                            onChangeObjectInjectionModalVisibleKey: _cache[2] || (_cache[2] = ($event: any) => (
                    emit('change-object-injection-modal-visible-key', $event)
                  )),
                            "override-object-list": _ctx.overrideObjectList,
                            onChangeOverrideObjectList: _cache[3] || (_cache[3] = ($event: any) => (
                    emit('change-override-object-list', $event)
                  )),
                            onOnInputChange: onInputChange
                          }, null, 8, ["request-bodies", "output-list", "user-defined-variables", "system-variables", "expressions", "step-idx", "metaoutput", "existing-data", "child-count", "connector-spec-id", "transformed-input", "transformed-output", "transformed-prompt", "is-step-changed", "is-simulating", "onUpdateData", "objectInjectionModalVisibleKey", "override-object-list"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 4)
                ], 10, _hoisted_10),
                _createVNode(FunctionSelector, {
                  "click-able-data-type": "branched",
                  "output-list": props.outputList,
                  "user-defined-variables": _ctx.userDefinedVariables,
                  "system-variables": _ctx.systemVariables,
                  expressions: _ctx.expressions,
                  mode: "input",
                  "show-other-inputs": true,
                  showMeta: true,
                  visible: 
              _ctx.objectInjectionModalVisibleKey ===
              `${key}-${val.path || val.name}-${index}`
            ,
                  "metaoutput-list": _ctx.metaoutput,
                  "show-exp-info": _ctx.showModal,
                  onAddMetaoutput: ($event: any) => (
              addMetaoutput(
                $event,
                key,
                val,
                index,
                `${key}-${val.path || val.name}-${index}`,
                `#accordion-${filterSpecialCharacters(
                  val.name
                )}-${_ctx.childCount}-${index}-${index}`
              )
            ),
                  onAddOutput: ($event: any) => (
              addOutput(
                $event,
                key,
                val,
                index,
                `${key}-${val.path || val.name}-${index}`,
                `#accordion-${filterSpecialCharacters(
                  val.name
                )}-${_ctx.childCount}-${index}-${index}`
              )
            ),
                  onAddUserVariable: ($event: any) => (
              addUserVariable(
                $event,
                key,
                val,
                index,
                `${key}-${val.path || val.name}-${index}`,
                `#accordion-${filterSpecialCharacters(
                  val.name
                )}-${_ctx.childCount}-${index}-${index}`
              )
            ),
                  drawerKey: `${key}-${val.path || val.name}-${index}`
                }, null, 8, ["output-list", "user-defined-variables", "system-variables", "expressions", "visible", "metaoutput-list", "show-exp-info", "onAddMetaoutput", "onAddOutput", "onAddUserVariable", "drawerKey"])
              ])
            ], 12, _hoisted_1)
          ], 2))
        }), 128))
      ]))
    }), 128))
  ], 64))
}
}

})